<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
	.tag-btn {
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div style="width: 50px;">金额：</div>
				<el-input size="small" v-model="amount" type="number" placeholder="操作金额" style="width: 140px;"></el-input>
				<div style="margin-left: 20px; width: 50px;">备注：</div>
				<el-input size="small" v-model="remark" placeholder="备注信息" style="width: 200px;"></el-input>
				<el-button size="small" style="margin-left: 10px;" type="danger" @click="actionWallet()">确认操作</el-button>
				<el-button size="small" style="margin-left: 180px;" type="success" @click="searchFunc()">刷新</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				size="mini"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
				
				<el-table-column prop="reason" label="标题" align="center">
				</el-table-column>
				
				<el-table-column prop="change_balance" label="变动金额" align="center" width="120">
				</el-table-column>
				
				<el-table-column prop="after_balance" label="剩余金额" align="center" width="120">
				</el-table-column>
				
				<el-table-column prop="auth_status" label="类型" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.types == 1" size="small">出票服务费</el-tag>
						<el-tag v-if="scope.row.types == 2" size="small" type="success">充值</el-tag>
						<el-tag v-if="scope.row.types == 3" size="small" type="info">会员跟单佣金</el-tag>
						<el-tag v-if="scope.row.types == 4" size="small" type="warning">会员发单佣金</el-tag>
						<el-tag v-if="scope.row.types == 5" size="small" type="danger">支付服务费</el-tag>
						<el-tag v-if="scope.row.types == 6" size="small" type="danger">后台操作</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="add_time" label="时间" width="200" align="center">
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
	</div> 
</template>

<script>
	
	export default {
		props:['sid'],
		data(){
			return {
				actionSid:0,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:15,
				
				amount:'',
				remark:'',
			}
		},
		watch:{
			sid(_new, _old){
				if(_new != _old){
					this.currentPage = 1;
					this.getData();
				}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			actionFunc(){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Shop/walletAction", {sid:_this.sid, amount:_this.amount, remark:_this.remark}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.$message({
							 message: '操作成功~',
							 type: 'success',
						});
						_this.searchFunc()
					}else{
						_this.$message({
							 message: '操作失败~',
							 type: 'warning',
						});
					}
					
				}).catch(res=>{
					_this.loading = false;
				});
			},
			actionWallet(){
				let _this = this;
				if(isNaN(this.amount) || this.amount == 0){
					return _this.$message({
						 message: '请输入正确的金额~',
						 type: 'warning',
					});
				}
				if(this.remark.trim().length == ''){
					return _this.$message({
						 message: '请输入备注信息~',
						 type: 'warning',
					});
				}
				this.$confirm('是否确认操作?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					console.log('12111');
				  _this.actionFunc();
				}).catch(() => {      
				});
			},
			searchFunc(){
				this.currentPage = 1;
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Shop/getShopWalletRecord", {page:this.currentPage, limit:this.limit, sid:that.sid}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

